import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'

export const changeRating = (
  dealId: string,
  values: {
    value: number
    rating_type: string
  },
) => apiClient.post(endpoints.dealRating(dealId), values)
